import { Stack } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./attributes_box.module.scss";

export const AttributesEmptyState = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.skillsFrameworks.sidePanel" });

  return (
    <Stack alignItems="center" gap="spacingSm" className={css.emptyState}>
      <Icon name="missing" color="paletteBlue2" />
      <Typography variant="labelRegular" className={css.emptyStateText}>
        {t("noAttributesAddedYet")}
      </Typography>
    </Stack>
  );
};
